"use client";

import { NeoNoisePage } from "@/components/site/neo-noise-page";
import { SiteFooter } from "@/components/site/site-footer";
import { SiteNav } from "@/components/site/site-nav";

export default function NeoNoise() {
  return (
    <div className="flex min-h-screen flex-col bg-background text-foreground">
      <SiteNav />
      <NeoNoisePage />
      <SiteFooter />
    </div>
  );
}
